import React, { useEffect, useState } from 'react';
import DefaultModalCertificates from '@/presentation/components/modalCertificates/modal-certificates';
const ModalCertificate = ({ open = true, onClose, children, grade }) => {
    const [bcColor, setBcColor] = useState('');
    useEffect(() => {
        if (grade >= 3 && grade <= 5) {
            setBcColor('white');
        }
        else {
            setBcColor('#FBF6F0');
        }
    }, []);
    return (React.createElement(DefaultModalCertificates, { backgroundColor: bcColor || null, height: "60", hUnit: "vh", open: open, onClose: () => onClose(), showClose: true }, children));
};
export default ModalCertificate;
